import { PlusInSquareIcon } from "assets/icons";
import { useBoolean } from "hooks";
import { t } from "i18next";
import { useState } from "react";
import { Button, Pagination, SearchInput } from "ui";

import { DeleteFAQItemModal, FAQItemModal, FAQTable } from "../../components";
import { FAQListItem } from "../../content.types";
import { useFaqItemsList } from "../../hooks";

import styles from "./FAQ.module.scss";

const FAQ = () => {
  const {
    faqItems,
    totalItems,
    pageCount,
    take,
    searchValue,
    setSearchValue,
    page,
    setPage,
    isLoading,
    setFaqItems
  } = useFaqItemsList();

  const {
    value: isFaqItemModalOpen,
    setTrue: openFaqItemModal,
    setFalse: closeFaqItemModal
  } = useBoolean(false);

  const [editableFaqItem, setEditableFaqItem] = useState<FAQListItem | null>(
    null
  );

  const [deleteFaqItemId, setDeleteFaqItemId] = useState<string | null>(null);

  return (
    <div className={styles.faq}>
      <div className={styles.faq_header}>
        <SearchInput value={searchValue} onChange={setSearchValue} />

        <Button icon={<PlusInSquareIcon />} onClick={openFaqItemModal}>
          {t("Add Question")}
        </Button>
      </div>

      <div className={styles.faq_table}>
        <FAQTable
          faqItems={faqItems ?? []}
          isLoading={isLoading}
          onDelete={setDeleteFaqItemId}
          onEdit={(faqItem) => {
            setEditableFaqItem(faqItem);
            openFaqItemModal();
          }}
          setFaqItems={setFaqItems}
          isDragDisabled={!!searchValue || pageCount > 1}
        />
      </div>

      <Pagination
        currentPage={page}
        onChange={setPage}
        totalItems={totalItems}
        perPage={take}
      />

      <FAQItemModal
        isOpen={isFaqItemModalOpen}
        editableItem={editableFaqItem}
        onClose={() => {
          closeFaqItemModal();
          setEditableFaqItem(null);
        }}
      />

      <DeleteFAQItemModal
        isOpen={!!deleteFaqItemId}
        id={String(deleteFaqItemId)}
        onClose={() => {
          setDeleteFaqItemId(null);
        }}
      />
    </div>
  );
};

export default FAQ;
